import axios from "axios";

export const state = {
    reportwithdrawspermembers: [],
};

export const getters = {
    reportwithdrawspermembers: state => state.reportwithdrawspermembers,
};

export const mutations = {
    setReportWithdrawsPerMember(reportwithdrawspermembers, newValue) { state.reportwithdrawspermembers = newValue},
};

export const actions = {
    async fetchReportWithdrawsPerMember({ commit }) {
        await axios.get('/reportwithdrawpermembers').then(res => {
            commit('setReportWithdrawsPerMember', res.data.withdraws)
        })
    },
    async filterReportWithdrawsPerMember({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportwithdrawpermembers";
        await axios.post(url, formData).then((response) => {
            commit('setReportWithdrawsPerMember', response.data.withdraws)
        })
    },
};
